export function h5Copy(value?: string | null) {
  return (value || '')
    .replaceAll('86上山Pub', '遨鹰 All in Pub')
    .replaceAll('86上山 PUB', '遨鹰 All in Pub')
    .replaceAll('86上山', '遨鹰')
    .replaceAll('存积分', '小鸡归巢')
    .replaceAll('取积分', '小鸡出巢')
    .replaceAll('存分', '小鸡归巢')
    .replaceAll('取分', '小鸡出巢')
    .replaceAll('积分', '小鸡')
    .replaceAll('POINTS', 'CHICKS')
}
